import { MatPaginatorIntl } from '@angular/material/paginator';

export function CustomMatPaginatorIntl(): MatPaginatorIntl {
  const customPaginatorIntl = new MatPaginatorIntl();
  customPaginatorIntl.itemsPerPageLabel = $localize`Items per page:`;
  customPaginatorIntl.nextPageLabel = 'Next';
  customPaginatorIntl.previousPageLabel = 'Previous';
  customPaginatorIntl.getRangeLabel = getRangeLabel.bind(this);

  return customPaginatorIntl;
}

function getRangeLabel(page: number, pageSize: number, length: number): string {
  let ofText = $localize`of`;

  if (length === 0 || pageSize === 0) {
    return `0 ${ofText} ${length}`;
  }
  length = Math.max(length, 0);
  const startIndex = page * pageSize;
  // If the start index exceeds the list length, do not try and fix the end index to the end.
  const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
  return `${startIndex + 1} - ${endIndex} ${ofText} ${length}`;
}
